import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Caret } from "commons";

export function CaretIcon({ size = "small" }) {
    return <Icon direction="right" size={size} />;
}

const Icon = styled(Caret)`
    && {
        position: absolute;
        right: ${props => (props.size === "large" ? "1rem" : "0")};
        top: calc(50% - ${props => (props.size === "large" ? "22px" : "15px")});
        height: ${props => (props.size === "large" ? "44px" : "30px")};
        width: ${props => (props.size === "large" ? "44px" : "30px")};

        @media (max-width: ${props => props.theme.maxWidth}) {
            width: 30px;
            height: 30px;
            top: calc(50% - 15px);
            right: 0;
        }
    }
`;

CaretIcon.propTypes = {
    size: PropTypes.oneOf(["small", "large"])
};
